import React, { useState } from "react";
import {
  Container,
  Grid,
  Box,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  Snackbar,
  Dialog,
  DialogContent,
  CircularProgress,
  Select,
  MenuItem,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import useNewCourseRequest from "./hooks/useNewCourseRequest"; // Adjust the path if needed
import CcpAdminBreadCrumbs from "../../Layout/CcpAdminBreadCrumbs";
import { faBarChart } from "@fortawesome/free-solid-svg-icons";

const CcpAdminNewCourseRequest = () => {
  const [formData, setFormData] = useState({
    courseRequest: "",
    startDate: "",
    endDate: "",
    modality: "",
    instructorType: "",
    instructorName: "",
    startTime: "",
    endTime: "",
    daysOfWeek: "",
    schoolName: "",
    fromName: "",
    schoolId: "1",
  });

  const pageName = "New Course Request";
  const icon = faBarChart;

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [loadingDialogOpen, setLoadingDialogOpen] = useState(false);
  const { postData } = useNewCourseRequest();

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingDialogOpen(true);
    try {
      await postData(formData);
      setSnackbarOpen(true);
      setFormData({
        courseRequest: "",
        startDate: "",
        endDate: "",
        modality: "",
        instructorType: "",
        instructorName: "",
        startTime: "",
        endTime: "",
        daysOfWeek: "",
        schoolName: "",
        fromName: "",
        schoolId: "1",
      });
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoadingDialogOpen(false);
    }
  };

  return (
    <Container sx={{ marginTop: "100px" }}>
      <CcpAdminBreadCrumbs pageName={pageName} icon={icon} />
      <Box sx={{ flexGrow: 1, marginTop: "10px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="New Course Request"
                avatar={<AddCircleOutlineIcon />}
                sx={{ bgcolor: "#AC1A2F", color: "white" }}
              />
              <CardContent>
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Course Request"
                        name="courseRequest"
                        value={formData.courseRequest}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Start Date"
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="End Date"
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        label="Modality"
                        name="modality"
                        value={formData.modality}
                        onChange={handleInputChange}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Select Modality</em>
                        </MenuItem>
                        <MenuItem value="face to face">Face to Face</MenuItem>
                        <MenuItem value="online">Online</MenuItem>
                        <MenuItem value="remote">Remote</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={6}>
                      <Select
                        label="Instructor Type"
                        name="instructorType"
                        value={formData.instructorType}
                        onChange={handleInputChange}
                        fullWidth
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Select Instructor Type</em>
                        </MenuItem>
                        <MenuItem value="Sinclair">Sinclair</MenuItem>
                        <MenuItem value="High School">High School</MenuItem>
                      </Select>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Instructor Name"
                        name="instructorName"
                        value={formData.instructorName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Start Time"
                        type="time"
                        name="startTime"
                        value={formData.startTime}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="End Time"
                        type="time"
                        name="endTime"
                        value={formData.endTime}
                        onChange={handleInputChange}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Days of Week"
                        name="daysOfWeek"
                        value={formData.daysOfWeek}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="School Name"
                        name="schoolName"
                        value={formData.schoolName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="From Name"
                        name="fromName"
                        value={formData.fromName}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{ bgcolor: "green", color: "white" }}
                        fullWidth
                      >
                        Submit
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
              <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                message="Request has been submitted"
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                ContentProps={{
                  sx: { bgcolor: "green", color: "white" },
                }}
              />
              <Dialog open={loadingDialogOpen}>
                <DialogContent>
                  <CircularProgress />
                </DialogContent>
              </Dialog>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default CcpAdminNewCourseRequest;
